import { createTheme } from "@mui/material";


export const FJSP_THEME = createTheme({
  palette: {
    primary: {
      main: '#53c2ba',
      dark: '#8966ac',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#8966ac'
    }
  },
  typography: {
    fontFamily: 'Arial, Arial Narrow, Nunito, Noto Sans JP, MS Gothic, sans-serif'
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          fontWeight: 'bold',
          padding: '8px 24px',
          lineHeight: 'normal'
        }
      }
    }
  }
})